import React from 'react'
import WhenDeviceAuthorized from 'support/conditionals/WhenDeviceAuthorized'
import ActiveWhenOnRoute from 'support/helpers/ActiveWhenOnRoute'
import * as UI from 'ui'

export default function TabletMenuItem (props) {
  return (
    <WhenDeviceAuthorized>
      <ActiveWhenOnRoute route={props.route}>
        <UI.TabletMenuItem {...props} />
      </ActiveWhenOnRoute>
    </WhenDeviceAuthorized>
  )
}
